export default "__VITE_ASSET__DZI$L1PA__"